import { useState } from 'react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline';

import {
  useRefinementList,
  UseRefinementListProps,
} from 'react-instantsearch-hooks-web';
import { Disclosure } from '@headlessui/react';

export type RefinementListProps = {
  label: string;
};

export const RefinementList = (
  props: UseRefinementListProps & RefinementListProps
) => {
  const [isOpen, setIsOpen] = useState(false);
  const { items, refine, canRefine } = useRefinementList(props);

  if (!canRefine) {
    return null;
  }

  return (
    <Disclosure as="div" className="border-b py-3 border-neutral-40">
      {({ open }) => (
        <>
          <h3 className="hd-md">
            <Disclosure.Button className="w-full flex items-center justify-between text-gray-400 hover:text-gray-500 py-5">
              <span>{props.label || props.attribute}</span>
              <span className="ml-6 flex items-center">
                {open ? (
                  <MinusSmallIcon className="h-5 w-5" aria-hidden="true" />
                ) : (
                  <PlusSmallIcon className="h-5 w-5" aria-hidden="true" />
                )}
              </span>
            </Disclosure.Button>
          </h3>
          <Disclosure.Panel className="pt-6">
            <div className="space-y-4">
              {items.map((item, i) => {
                const id = `filter-${item.label}-${item.value}`;
                return (
                  <div key={item.label} className="flex items-center w-full">
                    <input
                      className="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
                      id={id}
                      name={`${item.label}`}
                      type="checkbox"
                      value={item.value}
                      checked={item.isRefined}
                      onChange={() => refine(item.value)}
                    />
                    <label
                      htmlFor={id}
                      className="ml-3 text-sm text-gray-600 flex justify-between w-full"
                    >
                      <span>{item.label}</span>
                      <span className="rounded-sm bg-neutral-30 px-1 ml-auto">
                        {item.count}
                      </span>
                    </label>
                  </div>
                );
              })}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default RefinementList;
